<!-- 咨询记录 -->
<template>
  <a-drawer
    :title="`${Config.consultTypeEnum[consultType]}记录`"
    v-model:visible="visible"
    placement="right"
    :body-style="{ padding: '20px' }"
    width="50%"
    destroyOnClose
  >
    <div class="consult-container">
      <a-table
        :columns="consultType == 2 ? phoneColumns : videoColumns"
        :transformCellText="({ text }) => text ?? '--'"
        :pagination="false"
        :loading="loading"
        :data-source="tableData"
        :rowKey="(record, index) => index"
        :scroll="{ x: '100%', y: 'calc(100vh - 290px)' }"
      >
        <!-- 呼出人， callerType主叫方类型：1患者、2医生、3bd、4医生助手-->
        <template #callerType="{ record }">
          <div class="service_person">
            <roles :solerType="record.callerType" />
            <span>{{ record.callerName }}</span>
            <auth-img :src="callIcon" />
          </div>
        </template>
        <!-- 接听人 callerType主叫方类型：1患者、2医生、3bd、4医生助手-->
        <template #calleeName="{ record }">
          <div class="service_person">
            <roles :solerType="record.calleeType" />
            <span>{{ record.calleeName }}</span>
          </div>
        </template>
        <!-- 电话时长 -->
        <template #tcccDuration="{ record, index }">
          <template v-if="record.tcccDuration || record.fileDurationSecond">
            <div @click="play(index)" class="call_duration" v-if="!record.isPlay">
              <auth-img :src="playIcon" />
              <span>{{ renderTime(record.tcccDuration || record.fileDurationSecond) }}</span>
            </div>
            <div v-if="record.isPlay">
              <audio :src="record.audioUrl || record.fileUrl" controls ref="audioRef"></audio>
            </div>
          </template>
          <template v-else>--</template>
        </template>
      </a-table>
    </div>
  </a-drawer>
</template>
<script setup>
import { ref, nextTick, defineExpose } from 'vue'
import { phoneColumns, videoColumns } from './config'
import playIcon from '@/assets/img/chat/playIcon.png'
import callIcon from '@/assets/img/chat/callIcon.png'
import { renderTime } from '@/utils'
import { getConsultInfo } from '@/api/chat'
import Config from '@/config/index'

const visible = ref(false)
const tableData = ref([])
const loading = ref(false)
const audioRef = ref(null)
const consultType = ref(null)
const initData = async data => {
  const { id } = data || {}
  consultType.value = data?.consultType || null
  if (!id) return
  visible.value = true
  loading.value = true
  const params = {
    consultId: id
  }
  getConsultInfo(params)
    .then(res => {
      if (consultType.value == 2) {
        tableData.value = res?.callDetailRecords || []
      } else {
        tableData.value = res?.roomMeetingRecordList || []
      }
    })
    .finally(() => {
      loading.value = false
    })
}

// 播放录音
function play(index) {
  console.log(index)
  tableData.value.forEach(it => (it.isPlay = false))
  tableData.value[index].isPlay = true
  nextTick(() => {
    audioRef.value.play()
  })
}

//导出ref
defineExpose({
  initData
})
</script>
<style scoped lang="scss">
.consult-container {
  .service_person {
    img {
      margin-left: 8px;
    }
    .soler {
      font-weight: 400;
      font-size: 12px;
      border-radius: 4px;
      padding: 2px 6px;
      margin-right: 4px;
      &.pa {
        background: #ffeed9;
        color: #ffa940;
      }
      &.do {
        background: #d6eaff;
        color: #1890ff;
      }
      &.bd {
        color: #1fb5ab;
        background: #e6f5f1;
      }
      &.assistant {
        color: #722ed1;
        background: #f9f0ff;
      }
    }
    img {
      width: 16px;
      height: 16px;
    }
  }
  .call_duration {
    cursor: pointer;
    img {
      width: 16px;
      height: 16px;
      margin-right: 12px;
    }
  }
}
</style>
